module.exports = __webpack_public_path__ + "img/wave.139afef8.png";